import { Component, OnInit, OnDestroy } from "@angular/core";
import { PurchaseService } from "src/app/services/purchase/purchase.service";
import { InappService } from "src/app/services/inapp/inapp.service";
import { EventsService } from "src/app/services/event/event.service";
import { Platform } from "@ionic/angular";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { distinctUntilChanged, map, filter, takeUntil } from "rxjs/operators";
import { Subscription, Subject } from "rxjs";

@Component({
  selector: "app-store-purchases",
  templateUrl: "./store-purchases.component.html",
  styleUrls: ["./store-purchases.component.scss"],
})
export class StorePurchasesComponent implements OnInit, OnDestroy {
  private coinPurchases;
  private customerId;
  private customerSubscription: Subscription | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private purchaseService: PurchaseService,
    private InappService: InappService,
    private events: EventsService,
    private platform: Platform,
    private userSession: UserSessionService
  ) {
    this.events.subscribe("event:authentication:logout", () => {
      this.customerId = null;
    });

    this.getCustomer();
  }

  ngOnInit() {}
  intializeMobilePurchases(offers) {
    this.InappService.initializeStore(offers);
  }
  getPurchases() {
    let externalVendor = "iTunes";
    if (this.platform.is("android")) {
      externalVendor = "GooglePlay";
    }
    this.purchaseService.getAllPurchases(externalVendor).subscribe((res) => {
      if (res.result) {
        this.coinPurchases = this.formatPurchase(res.payload);
        this.intializeMobilePurchases(this.coinPurchases);
      }
    });
  }

  formatPurchase(payload) {


    const mapPayload = (data) => {
      return data.map((item, index) => {
        return {
          chips: item.chipsAmount,
          boydPoints: item.boydPoints,
          tierCredits: item.tierCredits,
          tag: item.tag,
          price: item.priceAmount,
          type: item.type,
          priceCode: item.priceCode,
        };
      });
    };

    return mapPayload(payload);
  }
  public getCustomer() {
    if (this.customerSubscription) {
      try {
        this.customerSubscription.unsubscribe();
      } catch (error) {
        console.error("Error when trying to unsubscribe:", error);
      }
      this.customerSubscription = null;
    }

    this.userSession.getCustomerSubscription().then((obs) => {
      this.customerSubscription = obs
        .pipe(
          takeUntil(this.destroy$),
          filter((customer) => !!customer),
          map((customer) => customer.customerId),
          distinctUntilChanged()
        )
        .subscribe((customerId) => {
          if (customerId) {
            this.customerId = customerId;
            this.getPurchases();
          }
        });
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
